<template>
  <div class="content">
    <div :class="platform == 'pc' ? 'u-success' : 'u-success-wap'">
      <img
        v-if="test !== '您的报名资料正在审核中'"
        :src="imgUrlObj[platform][status]"
        alt=""
      />
      <img
        v-if="test === '您的报名资料正在审核中'"
        :src="imgUrlObj[platform]['pending']"
        alt=""
      />
    </div>
    <div
      v-if="test === '您的报名资料正在审核中'"
      class="t-success"
      style="font-size: 20px; font-weight: bold; margin-bottom: 20px"
    >
      报名成功
    </div>
    <div class="t-success">
      {{ test }}
    </div>
  </div>
</template>
<script>
export default {
  name: "FormStatus",
  props: {
    status: String,
    test: String,
    platform: String,
  },
  data() {
    return {
      imgUrlObj: {
        pc: {
          nostart: require("@/assets/images/pc/icon-no-start.png"),
          over: require("@/assets/images/pc/icon-over.png"),
          error: require("@/assets/images/pc/icon-error.png"),
          pending: require("@/assets/images/wap/icon-success.png"),
        },
        wap: {
          nostart: require("@/assets/images/wap/icon-no-start.png"),
          over: require("@/assets/images/wap/icon-over.png"),
          error: require("@/assets/images/wap/icon-error.png"),
          pending: require("@/assets/images/wap/icon-success.png"),
        },
      },
    };
  },
};
</script>
